export var ReviewPlatform;
(function (ReviewPlatform) {
    ReviewPlatform["JUDGEME"] = "JUDGEME";
    ReviewPlatform["OKENDO"] = "OKENDO";
    ReviewPlatform["YOTPO"] = "YOTPO";
    ReviewPlatform["STAMPED"] = "STAMPED";
    ReviewPlatform["LOOX"] = "LOOX";
})(ReviewPlatform || (ReviewPlatform = {}));
